import { render, staticRenderFns } from "./DashboardSetting.vue?vue&type=template&id=02f62d26"
import script from "./DashboardSetting.vue?vue&type=script&lang=js"
export * from "./DashboardSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports